'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _CheckCircleOutlined = _interopRequireDefault(require('./lib/icons/CheckCircleOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _CheckCircleOutlined;
exports.default = _default;
module.exports = _default;